export function getInternetAmenityPlanIds(providers) {
  const amenityPlanIds = new Set();

  for (const provider of providers) {
    if (provider.plans) {
      for (const plan of provider.plans) {
        if (plan.internetAmenityPlanId) {
          amenityPlanIds.add(plan.id);
        }
      }
    }
  }

  return amenityPlanIds;
}

// Helper function to get the first internet amenity plan for backward compatibility
export function getFirstInternetAmenityPlan(providers) {
  for (const provider of providers) {
    if (provider.plans) {
      const firstPlanWithAmenityId = provider.plans.find((plan) => plan.internetAmenityPlanId);
      if (firstPlanWithAmenityId) {
        return firstPlanWithAmenityId;
      }
    }
  }
  return null;
}
